import { useDispatch } from "react-redux"
import { loadProfile as loadProfileUC } from "./useCases/load-profile/loadProfile.use-case"
import { initAuth as initAuthUC } from "./useCases/init-auth/initAuth.use-case"
import { logout as logoutUC } from "./useCases/logout/logout.use-case"
import { AppDispatch } from "core/src/store/store.types"
import { loginWithToken as loginWithTokenUC, LoginWithTokenRequest } from "./useCases/login-with-token/loginWithToken.use-case";
import { loginWithPasswordAndEmail as loginWithPasswordAndEmailUC, LoginWithPasswordAndEmailRequest } from "./useCases/login-with-password-and-email/loginWithPasswordAndEmail.use-case";

export const useAuthUseCases = () => {
    const dispatch = useDispatch<AppDispatch>()

    const loginWithToken = (args: LoginWithTokenRequest) => dispatch(loginWithTokenUC(args)).unwrap()
    const logout = () => dispatch(logoutUC()).unwrap()
    const loadProfile = () => dispatch(loadProfileUC()).unwrap()
    const initAuth = () => dispatch(initAuthUC()).unwrap()
    const loginWithPasswordAndEmail = (args: LoginWithPasswordAndEmailRequest) => dispatch(loginWithPasswordAndEmailUC(args)).unwrap()

    return {
        loginWithToken,
        logout,
        loadProfile,
        initAuth,
        loginWithPasswordAndEmail,
    }
}

export type UseAuthUseCases = ReturnType<typeof useAuthUseCases>;
